import { Map, Set, fromJS } from 'immutable';

import {
    ADD_ALL_MEDIA,
    UPDATE_MEDIA_EVENT_IDS,
    UPDATE_MEDIA,
    UPDATE_MEDIA_STATUS,
    CLEAR_REQUEST_IN_PROGRESS,
    REQUEST_SIGNED_URL,
    REQUEST_SIGNED_URL_ERROR,
    UPDATE_SIGNED_URL,
    REQUEST_MEDIA_FROM_RAVEN,
    REQUEST_MEDIA_FROM_RAVEN_SUCCESS,
    REQUEST_MEDIA_FROM_RAVEN_ERROR,
    VIDEO_PLAYBACK_ERROR,
    CLEAR_PLAYBACK_ERROR,
} from './actions';

const initialState = {
    mediaMap: Map({}),
}

const updateMedia = (mediaMap, {ravenUuid, media}) => {
    return mediaMap.mergeIn([ravenUuid, media.mediaId], fromJS(media));
};

const updateMediaEventIds = (mediaMap, {ravenUuid, eventList}) => {
    return mediaMap.withMutations(map => {
        eventList.forEach(({ eventId, mediaIds }) => {
            if(!mediaIds) return;
            mediaIds.forEach(mediaId =>
                map.mergeIn([ravenUuid, mediaId], { eventIds: Set([eventId]) })
            );
        });
    });
}

const addAllMedia = (mediaMap, {ravenUuid, mediaList}) => {
    return mediaMap.withMutations(map =>
        mediaList.forEach(media =>
            map.mergeDeepIn([ravenUuid, media.mediaId], fromJS(media))
        )
    );
};

export default function(state = initialState, action) {
    switch(action.type) {
        case ADD_ALL_MEDIA:
            return {
                mediaMap: addAllMedia(state.mediaMap, action.payload)
            };
        case UPDATE_MEDIA:
            return {
                mediaMap: updateMedia(state.mediaMap, action.payload)
            };
        case UPDATE_MEDIA_STATUS: {
            const { ravenUuid, mediaId, status, statusTime } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        status,
                        statusTime
                    }
                })
            };
        }
        case CLEAR_REQUEST_IN_PROGRESS: {
            const { ravenUuid, sourceMediaId, productMediaId, cameraType, mediaType } = action.payload;
            return {
                mediaMap: state.mediaMap.withMutations(map => {
                    map.mergeDeepIn([ravenUuid, sourceMediaId], fromJS({ requestInProgress: null, timeoutId: null }));
                    map.mergeDeepIn([ravenUuid, productMediaId], fromJS({ cameraType, type:mediaType }));
                })
            };
        }
        case REQUEST_SIGNED_URL: {
            const { ravenUuid, mediaId } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        signedUrlRequestInProgress: true,
                        signedUrlRequestError: null
                    }
                })
            };
        }
        case REQUEST_SIGNED_URL_ERROR: {
            const { ravenUuid, mediaId, err } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap,
                    {
                        ravenUuid,
                        media: {
                            mediaId,
                            signedUrlRequestInProgress: false,
                            signedUrlRequestError: err
                        }
                    }
                )
            }
        }
        case UPDATE_SIGNED_URL: {
            const { ravenUuid, mediaId, signedUrl } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        signedUrlRequestInProgress: false,
                        signedUrl
                    }
                })
            };
        }
        case REQUEST_MEDIA_FROM_RAVEN: {
            const { ravenUuid, mediaId, request, timeoutId  } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        requestInProgress: request,
                        error: null, /* clear any previous error */
                        timeoutId
                    }
                })
            };
        }
        case REQUEST_MEDIA_FROM_RAVEN_ERROR: {
            const { ravenUuid, mediaId, err } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        requestInProgress: null,
                        error: err
                    }
                })
            };
        }
        case REQUEST_MEDIA_FROM_RAVEN_SUCCESS: {
            // nothing to do
            return state;
        }
        case UPDATE_MEDIA_EVENT_IDS: {
            return {
                mediaMap: updateMediaEventIds(state.mediaMap, action.payload)
            };
        }
        case VIDEO_PLAYBACK_ERROR: {
            const { ravenUuid, mediaId, error } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        playbackError: error,
                    }
                })
            };
        }
        case CLEAR_PLAYBACK_ERROR: {
            const { ravenUuid, mediaId } = action.payload;
            return {
                mediaMap: updateMedia(state.mediaMap, {
                    ravenUuid,
                    media: {
                        mediaId,
                        playbackError: null,
                    }
                })
            };
        }
        default:
            return state;
    }
};
